import { notification } from '@honestica/ui-kit/src';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const NETWORK_OFFLINE_NOTIFICATION_KEY = 'network-offline';

export function useOnOffline(callback: () => void) {
  useEffect(() => {
    window.addEventListener('offline', callback, { passive: true });
    return () => window.removeEventListener('offline', callback);
  }, [callback]);
}

export function useOnOnline(callback: () => void) {
  useEffect(() => {
    window.addEventListener('online', callback, { passive: true });
    return () => window.removeEventListener('online', callback);
  }, [callback]);
}

export function useNotifyNetworkOffline() {
  const { t } = useTranslation();

  useOnOffline(() => {
    notification.error({
      key: NETWORK_OFFLINE_NOTIFICATION_KEY,
      message: t('appstore.error.network.label'),
      placement: 'topRight',
      duration: 0,
    });
  });

  useOnOnline(() => {
    notification.destroy(NETWORK_OFFLINE_NOTIFICATION_KEY);
  });
}
